import { useState } from "react";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";
import { CreateTagForm } from "./create-tag-form";

export function CreateTagButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <PlusIcon className="mr-2 h-4 w-4" />
        Create Tag
      </Button>
      <CreateTagForm open={open} onOpenChange={setOpen} />
    </>
  );
}
